import DataTable from 'components/organisms/data-table'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import merchantProductTableColumns from 'domains/merchant-product/molecules/table-column'

const propTypes = {
  data           : PropTypes.array,
  pagination     : PropTypes.object,
  onFetchData    : PropTypes.func,
  hiddenColumns  : PropTypes.array,
  isLoading      : PropTypes.bool,
  rowButtonProps : PropTypes.shape({
    buttonText       : PropTypes.string,
    buttonColour     : PropTypes.string,
    onButtonClick    : PropTypes.func,
    isButtonDisabled : PropTypes.func
  })
}

const defaultProps = {
  hiddenColumns  : [],
  isLoading      : false,
  rowButtonProps : {
    buttonText       : 'Process',
    buttonColour     : 'default',
    onButtonClick    : () => {},
    isButtonDisabled : () => {}
  }
}

/**
 * Table to display Merchant Product for receiving
 * @param {Array<Object>} data - array of Merchant Product
 * @param {Object} pagination - object of pagination data from endpoint
 * @param {Function} onFetchData - function that will call endpoint for data
 * @param {Boolean} isLoading - whether the table is currently loading data from the backend
 */
const MerchantProductTable = ({
  data,
  pagination,
  onFetchData,
  rowButtonProps,
  hiddenColumns,
  isLoading
}) => {

  const { buttonText, buttonColour, onButtonClick, isButtonDisabled } = rowButtonProps

  const columns = useMemo(
    () => merchantProductTableColumns({
      buttonColour,
      buttonText,
      onButtonClick,
      isButtonDisabled
    }),
    [
      buttonColour,
      buttonText,
      onButtonClick,
      isButtonDisabled
    ]
  )

  return (
    <DataTable
      data={ data }
      columns={ columns }
      pagination={ pagination }
      onFetchData={ onFetchData }
      isLoading={ isLoading }
      hiddenColumns={ hiddenColumns }
    />
  )
}

MerchantProductTable.propTypes    = propTypes
MerchantProductTable.defaultProps = defaultProps

export default MerchantProductTable
